import { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import {
    Button,
    TextField,
    Box,
    Stack,
    Divider,
    Typography,
    FormControl
} from '@mui/material';
import { SelectGenericFromTable, GetDensityNetworkConfigFile } from '../universal/Axios';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
import { IsJsonString } from '../universal/JSONHelper';
const store = getStore();


const UploadDensityNetworkConfig = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const parent_id = queryParameters.get("parent-id")
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const [parentDensityNetworkConfigFile, setParentDensityNetworkConfigFile] = useState(true);
    const [id, setID] = useState("");
    const [existingIDs, setExistingIDs] = useState([])
    const [fileContent, setFileContent] = useState("");
    const [errorMessages, setErrorMessages] = useState({});

    useEffect(() => {
        SelectGenericFromTable("select id from density_network_config;", setExistingIDs)
    }, []);

    useEffect(() => {
        if (parent_id !== null) {
            GetDensityNetworkConfigFile(parent_id, setParentDensityNetworkConfigFile)
        }
    }, []);

    useEffect(() => {
        validateForm()
    }, [id, fileContent])

    useEffect(() => {
        checkSubmitButtonDisabled()
    }, [errorMessages])

    const uploadDensityNetworkConfig = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Upload_Density_Network_Config",
                "id": id,
                "parent_id": parent_id,
                "file_content": JSON.parse(fileContent),
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully created Density Network Config!")
            window.location.href = "density-network-configs"
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Density Network Config")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while creating heat map")
                }
            }
        })
    }

    const validateForm = () => {
        //ID Section
        if (existingIDs.map(x => x["id"]).indexOf(id) === -1) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "A density network config with that ID already exists" }))
        }

        if (id === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "No ID" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "" }))
        }

        //File Content Section
        if (fileContent === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_file_content"]: "No file content" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_file_content"]: "" }))
        }

        if (!IsJsonString(fileContent)) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["is_valid_json"]: "File Content is not valid JSON" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["is_valid_json"]: "" }))
        }
    }

    const checkSubmitButtonDisabled = () => {
        const has_errors = Object.keys(errorMessages).map(x => errorMessages[x]).some(x => x !== "")
        setSubmitButtonDisabled(has_errors)
    }

    return (
        <Box>
            <Typography sx={{ marginBottom: '20px' }} variant="h6">Upload {parent_id !== null ? "Adjustment " : "Base "} Density Network Config</Typography>
            <Box sx={{ m: 2 }}>
                {parent_id !== null && <>Parent ID: <b>{parent_id}</b></>} 
                <FormControl fullWidth>
                    {errorMessages["has_id"] !== undefined && <Typography color="red">{errorMessages["has_id"]}</Typography>}
                    {errorMessages["uniqueness"] !== undefined && <Typography color="red">{errorMessages["uniqueness"]}</Typography>}
                    <TextField
                        id="id"
                        label="ID"
                        variant="outlined"
                        multiline
                        value={id}
                        maxRows={5000}
                        onChange={(event) => setID(event.target.value)}
                        helperText={errorMessages.id}
                        sx={{ marginBottom: '10px' }}
                    />
                    {errorMessages["has_file_content"] !== undefined && <Typography color="red">{errorMessages["has_file_content"]}</Typography>}
                    {errorMessages["is_valid_json"] !== undefined && <Typography color="red">{errorMessages["is_valid_json"]}</Typography>}
                    <TextField
                        id="file_content"
                        label="File Content"
                        variant="outlined"
                        multiline
                        rows={10}
                        value={fileContent}
                        maxRows={5000}
                        onChange={(event) => setFileContent(event.target.value)}
                        helperText={errorMessages.id}
                    />
                </FormControl>
            </Box>
            <Divider />
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button href={parent_id !== null ? "edit-density-network-config?id=" + parent_id : "density-network-configs" }>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={() => uploadDensityNetworkConfig()}
                        disabled={isSubmitButtonDisabled}
                    >
                        Submit
                    </Button>
                </Stack>
            </Box>
            {parent_id !== null &&
                <>
                    <Box sx={{ display: "flex", justifyContent: "center", marginTop: '20px', fontSize: '20px' }}>
                        <b>Parent File Content:</b>
                    </Box>
                {parentDensityNetworkConfigFile === "" && <div>Loading...</div>}
                    <Box sx={{ display: "flex", justifyContent: "center", marginTop: '20px' }}>
                        <Box component="div" sx={{ border: 1, overflow: 'auto', width: '1000px', height: '500px' }}>
                            <pre>{parentDensityNetworkConfigFile}</pre>
                        </Box>
                    </Box>
                </>
            }
        </Box>
    )
}

export default UploadDensityNetworkConfig;